@if (hasTechnicalError) {
  <technical-error></technical-error>
}
@if (configObservable | async; as config) {
  @if (!hasTechnicalError) {
	  @if (occupationalProfileObservable | async; as occupationalProfile) {
		<div class="container beroepenfiche" id="occupationalProfileDetailDiv">
			<occupational-profile-base-info [occupationalProfile]="occupationalProfile" [config]="config"></occupational-profile-base-info>
			<occupational-profile-movie [occupationalProfile]="occupationalProfile"></occupational-profile-movie>
			<occupational-profile-info-package
			[occupationalProfile]="occupationalProfile"></occupational-profile-info-package>
			<occupational-profile-competences
			[occupationalProfile]="occupationalProfile"></occupational-profile-competences>
			<occupational-profile-charts [occupationalProfile]="occupationalProfile"
			[config]="config"></occupational-profile-charts>
			<section class="o-wrapper" id="opleidingen-voor">
				<vindeenopleiding-widget-opleidingen-voor-beroep
					[beroep-id]="occupationalProfile.id"
					[beroep-naam]="occupationalProfile.title?.nl">
				</vindeenopleiding-widget-opleidingen-voor-beroep>
			</section>
			<section class="o-stretch-wrapper u-bg-blue-100" id="vacatures-voor">
			  <vindeenjob-widget-beroepen
				[beroep-id]="occupationalProfile.id"
				[beroeps-titel]="occupationalProfile.title?.nl">
			  </vindeenjob-widget-beroepen>
			</section>
		  <occupational-profile-orientation
		  [occupationalProfileTitle]="occupationalProfile.title?.nl"></occupational-profile-orientation>
		</div>
	  }
  }
}
